<template>
    <div>
        <AppNavbar />
        <PagesHero :breadcrumbData="{
            title: $t('our_services.title'),
            subtitle: {
                first_text: $t('our_services.label'),
                first_href: '/',
                second_text: $t('our_services.title')
            }
        }" />
        <div class="container">
            <div class="row justify-content-center">
                <img src="@/assets/images/ourservices/services.webp" class="img" />
            </div>
            <h2>{{ $t('our_services.intro') }}</h2>
            <p>{{ $t('our_services.intro_paragraph') }}</p>
            <h2>{{ $t('our_services.quran_programs_pros') }}</h2>
            <div class="pros_container">
                <div class="d-flex flex-row ">
                    <div class="align-items-center justify-content-center">
                        <img src="@/assets/images/ourservices/pro1.webp" class="pros">
                    </div>
                    <div>
                        <h3>{{ $t('our_services.pros1') }}</h3>
                        <span>{{ $t('our_services.pros1_paragraph') }}</span>
                    </div>
                </div>
                <div class="d-flex flex-row ">
                    <div class="align-items-center justify-content-center">
                        <img src="@/assets/images/ourservices/pro2.webp" class="pros">
                    </div>
                    <div>
                        <h3>{{ $t('our_services.pros2') }}</h3>
                        <span>{{ $t('our_services.pros2_paragraph') }}</span>
                    </div>
                </div>
                <div class="d-flex flex-row ">
                    <div class="align-items-center justify-content-center">
                        <img src="@/assets/images/ourservices/pro3.webp" class="pros">
                    </div>
                    <div>
                        <h3> {{ $t('our_services.pros3') }} </h3>
                        <span>{{ $t('our_services.pros3_paragraph') }}</span>
                    </div>
                </div>
            </div>

            <h2>{{ $t('our_services.goal') }}</h2>
            <p>{{ $t('our_services.goal_paragraph') }}</p>
            <h2>{{ $t('our_services.services') }}</h2>
            <ServicesCards />
        </div>
        <AppFooter />
    </div>
</template>

<script>
import AppNavbar from '@/components/AppNavbar.vue';
import AppFooter from '@/components/AppFooter.vue';
import PagesHero from '@/components/PagesHero.vue';
import ServicesCards from '@/components/Home/ourservices/servicesCards.vue';

export default {
    components: {
        AppFooter, AppNavbar, PagesHero, ServicesCards
    }
}
</script>

<style scoped>
.row {
    margin-top: 40px;
}

.img {
    height: 418px;
    width: auto;
    object-fit: cover;
    margin-bottom: 50px;
}

h2 {
    font-size: 36px;
    font-weight: 500;
    margin-bottom: 30px;
}

p {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 40px;
}

h3 {
    font-size: 22px;
    font-weight: 500;
}

span {
    font-size: 22px;
    font-weight: 400;
}

.container {
    padding-bottom: 80px;
}

.pros {
    height: 55px;
    width: auto;
    object-fit: contain;
    margin-inline-end: 10px;
}

.pros_container {
    margin-bottom: 40px;
}

.pros_container .flex-row {
    margin-bottom: 50px;
}
</style>